var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedTrashLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.166 4h4.167v1.666h-1.666v10.833a.833.833 0 01-.834.834H3.167a.833.833 0 01-.834-.834V5.666H.667V3.999h4.166V1.5a.833.833 0 01.833-.833h6.667a.833.833 0 01.833.833V4zM14 5.665H4v10h10v-10zM6.5 2.333v1.666h5V2.333h-5z",
    fill: "#DB4957"
  })));
}

export default SvgLedTrashLogo;